// Shared site content & assets for L3 Construction Homebuilding

export const BUSINESS = {
  name: "L3 Construction",
  tagline: "Homebuilding",
  phone: "775-447-5711",
  phoneHref: "tel:+17754475711",
  emails: ["james@l3construct.com", "jacob@l3construct.com"],
  serviceArea: "Reno, NV & Northern Nevada",
  experienceYears: 60,
};

export const ASSETS = {
  logo: "https://static.prod-images.emergentagent.com/jobs/d37181bc-7262-4300-94e9-4213eb06d587/images/061cfcdb240c60aeba647915cf2be3e7577ec2aa15dd33b481e94f0f6c38eb6e.png",
  heroTools: "https://images.unsplash.com/photo-1611021061218-761c355ed331?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  toolRack: "https://images.unsplash.com/photo-1426927308491-6380b6a9936f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  artisan: "https://images.pexels.com/photos/27155225/pexels-photo-27155225.jpeg",
  rusticKitchen: "https://images.pexels.com/photos/33640979/pexels-photo-33640979.jpeg",
  framing: "https://images.unsplash.com/photo-1609867271967-a82f85c48531?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const PROJECTS = [];

export const SERVICES = [
  {
    icon: "Home",
    title: "Custom Home Building",
    desc: "From the first sketch to the final walkthrough, we build beautifully designed homes tailored to the way you live.",
  },
  {
    icon: "Hammer",
    title: "Remodels & Renovations",
    desc: "Kitchens, baths, additions and whole-home transformations executed with meticulous craftsmanship.",
  },
  {
    icon: "Trees",
    title: "Outdoor Living",
    desc: "Decks, patios, outdoor kitchens and living spaces designed to bring your backyard to life.",
  },
  {
    icon: "Ruler",
    title: "Design & Planning",
    desc: "Collaborative design and engineering support to turn your vision into a buildable, budget-aware plan.",
  },
  {
    icon: "HardHat",
    title: "New Construction",
    desc: "Ground-up framing, structural and site work backed by decades of hands-on field experience.",
  },
  {
    icon: "ClipboardList",
    title: "Project Management",
    desc: "One point of contact, clear timelines and honest communication from concept to completion.",
  },
];

export const HIGHLIGHTS = [
  {
    icon: "Home",
    title: "Custom Homes",
    desc: "Beautifully designed homes built for your lifestyle.",
  },
  {
    icon: "Hammer",
    title: "Quality Craftsmanship",
    desc: "Every detail matters. Built to last for generations.",
  },
  {
    icon: "ShieldCheck",
    title: "Trust & Integrity",
    desc: "Honest communication and reliable service you can count on.",
  },
  {
    icon: "Award",
    title: "60+ Years Combined",
    desc: "Our owners bring over six decades of combined homebuilding experience.",
  },
];
